class ContactMapper {

	toDomain(persistenceCategory) {
		return {
			id: persistenceCategory.id,
			name: persistenceCategory.name
		};
	}

}

export default new ContactMapper();
